/**
 * @generated SignedSource<<99ccbcbab2858eccf06f5204cfe8a525>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameEmailTemplateInput = {
  id: string;
  name: string;
};
export type EmailTemplateViewRenameMutation$variables = {
  input: RenameEmailTemplateInput;
};
export type EmailTemplateViewRenameMutation$data = {
  readonly renameEmailTemplate: {
    readonly id: string;
    readonly name: string;
  };
};
export type EmailTemplateViewRenameMutation = {
  response: EmailTemplateViewRenameMutation$data;
  variables: EmailTemplateViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "renameEmailTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c446be921bc549e8a9576c9922e6df7",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplateViewRenameMutation(\n  $input: RenameEmailTemplateInput!\n) {\n  renameEmailTemplate(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e97bb3e91f29b4ef0f196eee8f908e9";

export default node;
